
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/wallet-api",
      function () {
        return require("private-next-pages/products/wallet-api.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/wallet-api"])
      });
    }
  